import { lazyPage, type ModulePlugin } from "@keel/core";

const parties = () => import("./Parties");
const products = () => import("./Products");
const PartiesList = lazyPage(parties, "PartiesList");
const PartyPage = lazyPage(parties, "PartyPage");
const ProductsList = lazyPage(products, "ProductsList");
const ContactsList = lazyPage(() => import("./Contacts"), "ContactsList");
const ProductPage = lazyPage(products, "ProductPage");
const MasterdataSetupTab = lazyPage(() => import("./Setup"), "MasterdataSetupTab");

/**
 * Master data: customers, suppliers, products — shared by every company of the tenant.
 * Ported from the prototype's `pages/master/*`. Nav items join the Sales, Purchasing and Inventory
 * groups exactly like the prototype's sidebar.
 */
const plugin: ModulePlugin = {
  key: "masterdata",
  records: { Customer: "/customers/", Supplier: "/suppliers/", Product: "/products/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Sales",
      items: [
        { to: "/customers", label: "Customers", icon: "users", perm: "masterdata.customers.read" },
        { to: "/contacts", label: "Contacts", icon: "user", perm: "masterdata.customers.read" },
      ],
    },
    {
      group: "Purchasing",
      items: [{ to: "/suppliers", label: "Suppliers", icon: "factory", perm: "masterdata.suppliers.read" }],
    },
    {
      group: "Inventory",
      items: [{ to: "/products", label: "Products", icon: "box", perm: "masterdata.products.read" }],
    },
  ],
  routes: [
    { path: "/customers", element: <PartiesList kind="customers" /> },
    { path: "/customers/:id", element: <PartyPage kind="customers" /> },
    { path: "/contacts", element: <ContactsList /> },
    { path: "/suppliers", element: <PartiesList kind="suppliers" /> },
    { path: "/suppliers/:id", element: <PartyPage kind="suppliers" /> },
    { path: "/products", element: <ProductsList /> },
    { path: "/products/:id", element: <ProductPage /> },
  ],
  settingsTabs: [
    {
      key: "masterdata",
      label: "Master data",
      perm: "masterdata.setup.read",
      element: <MasterdataSetupTab />,
    },
  ],
  commands: [
    ["Setup lists", "/settings?tab=masterdata", "settings", "masterdata.setup.read"],
    ["New product", "/products/new", "plus", "masterdata.products.write"],
    ["New customer", "/customers?new=1", "plus", "masterdata.customers.write"],
    ["New supplier", "/suppliers?new=1", "plus", "masterdata.suppliers.write"],
    ["Products", "/products", "box", "masterdata.products.read"],
    ["Customers", "/customers", "users", "masterdata.customers.read"],
    ["Contacts", "/contacts", "user", "masterdata.customers.read"],
    ["New contact", "/contacts?new=1", "plus", "masterdata.customers.write"],
    ["Suppliers", "/suppliers", "factory", "masterdata.suppliers.read"],
  ],
  newMenu: [
    { label: "Product", to: "/products/new", perm: "masterdata.products.write", section: "Master data" },
    { label: "Customer", to: "/customers?new=1", perm: "masterdata.customers.write", section: "Master data" },
    { label: "Contact", to: "/contacts?new=1", perm: "masterdata.customers.write", section: "Master data" },
    { label: "Supplier", to: "/suppliers?new=1", perm: "masterdata.suppliers.write", section: "Master data" },
  ],
  sources: { customer: "/customers/", supplier: "/suppliers/", product: "/products/" },
};
export default plugin;
